define([
	"dojo/_base/declare",
	"csi/def",
	"csi/def/Action",
	"csi/locale",
	"csi/xml"
], function(declare, def, Action, locale, xml) {

	return declare(Action, {
		bUp: false,

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.setMaterialIcon(this.bUp ? "arrow_upward" : "arrow_downward");
			}

			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		getDescription: function() {
			// summary: if on toolbar, then no keyboard input
			const s = this.inherited(arguments);
			return this.bActOnSelections ? s : (s + locale.resource("Move_Keyboard"));
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable if view is sorted
			const qr = ctx.queryResult || ctx.view.getQueryResult(ctx.getNodeURL());
			const qrParent = qr?.parentResult;

			if (!qrParent || qrParent.isSorted() || qrParent.bNewlyCreated) {
				return false;
			}

			return this.inherited(arguments);
		},

		/**
		 * Remove Up/Down actions from actions column
		 * FIXED_WIDTH: this is temporary solution to remove icons for all MoveUp/MoveDown actions, and instead rely on DnD.
		 * If this change is confirmed, we can possibly remove the actions entirely, but then we need to ensure DnD still works as
		 * it relies on them.
		 */
		toHtml: () => null,
		toHtmlWithAccess: () => null,
		toHtmlWithoutAccess: () => null,
	});
});